import React, {useEffect,useState} from "react";

import {FaArrowLeft} from "react-icons/fa";
import {useNavigate} from "react-router-dom";
import {BackButton, HeaderLeft, Title, Container, MainSection, Content, Header} from "../common/styles";

const BusinessTrips = () => {
  const navigate = useNavigate()
  const handleBack = () => {
    navigate('/');
  };

  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadWebComponent = async () => {
      try {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = import.meta.env.VITE_BUSINESS_TRIPS_COMPONENT_URL;
        script.onload = () => {
          setLoaded(true);
        };
        document.head.appendChild(script);
      } catch (err) {
        console.error('Error:', err);
        setError(true);
      }
    };

    loadWebComponent();
  }, []);

  return (
      <Container>
        <Header>
          <HeaderLeft>
            <BackButton onClick={handleBack}>
              <FaArrowLeft /> Back to Home
            </BackButton>
            <Title>My Trips</Title>
          </HeaderLeft>
        </Header>
        <Content>
          <MainSection style={{ padding:'0px' }}>
            {error && <p>Couldn't load web component</p>}
            {loaded && <business-trips-component></business-trips-component>}
          </MainSection>
        </Content>
      </Container>
  );
};

export default BusinessTrips;
